import Handlebars from 'handlebars';

(function($) {
    "use strict";

    const $form = $('form[data-resource-center-filter]');
    $form.on('submit', function (e) {
        e.preventDefault();
        window.location.href = '/national-resource-center/resources#' + jQuery.param(getSearchQuery());
    });

    var _pager = new PHI.Pager();

    const requestResources = (e) =>
    {
        if (e) resetFilterItem(e);

        $('.loading-overlay').show();
        PHI.api.getResourceCenter(getSearchQuery(), function (d) {
            $('.loading-overlay').hide();
            var items = d.data ? d.data.items : [],
            total = d.data ? d.data.total_found : 0,
            $list = $('#results-list');
            const tpl = $('#template-resource').html();
            $list.empty();

            for (var i = 0; i < items.length; i++) {
                const template = Handlebars.compile(tpl);
                const data = items[i]
                data.title = data.short_title?.length ? data.short_title : data.title;
                data.description = data.short_description;
                data.topics = Array.isArray(data.topics) ? $('<textarea />').html(data.topics.join(', ')).val() : null;
                data.resource_center_issues = Array.isArray(data.resource_center_issues) ? $('<textarea />').html(data.resource_center_issues.join(', ')).val() : null;
                data.researchFocuses = Array.isArray(data.researchFocuses) ? $('<textarea />').html(data.researchFocuses.join(', ')).val() : null;
                data.regions = Array.isArray(data.regions) ? $('<textarea />').html(data.regions.join(', ')).val() : null;
                $list.append(template(data));
            }
            var begin = getSearchQuery().offset + 1,
            end = getSearchQuery().offset + PHI.api.PAGE_SIZE;

            if (0 === total) {
                $('#results-counts').text('No items found');
                return;
            }
            var end = getSearchQuery().offset + PHI.api.PAGE_SIZE;

            if (end > total) end = total;
            if (total < 10) end = total;

            var $results = $('#results-count');
            const templateCount = Handlebars.compile($("#template-resource-result-count").html());
            $results.empty();
            $results.append(templateCount({
                begin: begin,
                end: end,
                total: total
            }));
            _pager.render(total, PHI.api.PAGE_SIZE);
        });
    }

    function syncFormWithUrlParams ()
    {
        if (!window.location.hash.length) return;
        const queryString = window.location.hash.substr(1);
        const queryObject = JSON.parse('{"' + decodeURI(queryString).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}');

        if (queryObject.search.length)
            $('#keyword')
                .val(decodeURIComponent(queryObject.search));

        if (queryObject.topic.length)
            $("#filter-topic")
                .val(decodeURIComponent(queryObject.topic))
                .trigger('change');

        if (queryObject.type.length)
            $("#filter-type")
                .val(decodeURIComponent(queryObject.type))
                .trigger('change');

        if (queryObject.issue.length)
            $("#filter-issue")
                .val($(`#filter-issue option:contains(${decodeURIComponent(queryObject.issue)})`).val())
                .trigger('change');


    }

    function resetFilterItem (e)
    {
        if (e.params && 'unselect' === e.params._type)
        {
            $(e.target).val('');
            _pager.reset();
        } else if ('pagination' !== e.type)
        {
            _pager.reset();
        }
    }


    function resetFilters (e)
    {
        e.preventDefault();

        $('#keyword').val('');
        $('#filter-topic,#filter-type,#filter-issue,#filter-region,#filter-research-focus,#date-from,#date-to').val('').trigger('change');
        $('#filter-phi-authored').prop('checked', false);

        $('.loading-overlay').show();

        _pager.reset();

        requestResources();

        return false;
    }


    function getSearchQuery ()
    {
        let query = {
            offset: _pager.offset(),
            search: $('#keyword').val(),
            topic: $('#filter-topic option:selected').val(),
            type: $('#filter-type option:selected').val(),
            issue: $('#filter-issue option:selected').text(),
            region: $('#filter-region option:selected').text(),
            researchFocus: $('#filter-research-focus option:selected').text(),
            from: $('#date-from').val(),
            to: $('#date-to').val(),
        };
        if ($('#filter-phi-authored').is(":checked")) {
            query.phiAuthored = 1;
        }
        // Apply filters enforced by the url
        const fixedIssueFilters = {
            '/national-resource-center/issue/financing/': 'Financing',
            '/national-resource-center/issue/compensation/': 'Compensation',
            '/national-resource-center/issue/training/': 'Training',
            '/national-resource-center/issue/workforce-interventions/': 'Workforce Interventions',
            '/national-resource-center/issue/data-collection/': 'Data Collection',
            '/national-resource-center/issue/direct-care-workers/': 'Direct Care Workers',
        }
        if (fixedIssueFilters[window.location.pathname]) {
            query.issue = fixedIssueFilters[window.location.pathname];
        } else {
            console.log('No fixed issue filter for this page: ', window.location.pathname);
        }

        return query;
    }
    function togglePhiAuthoredClass () {
        if ($('#filter-phi-authored').is(":checked")) {
            $('#filter-phi-authored').prev().addClass('phi-authored-true')
        } else {
            $('#filter-phi-authored').prev().removeClass('phi-authored-true')
        }
    }


    /* Only run on resource center hub */
    if (!$('.page-resource-center-hub').length) return;

    // init
    syncFormWithUrlParams();
    _pager.init('.pager-container', null, requestResources);
    $('#keyword').on('keydown', _.debounce(requestResources, 1000));
    $('#keyword').on('keydown', _.debounce(requestResources, 1000));
    $('#filter-topic,#filter-type,#filter-issue,#filter-region,#filter-research-focus').on('select2:select', requestResources);
    $('#filter-topic,#filter-type,#filter-issue,#filter-region,#filter-research-focus').on('select2:unselect', requestResources);
    $('#filter-phi-authored').change(function() {
        togglePhiAuthoredClass()
        requestResources()
    });
    $('#date-from, #date-to').change(requestResources);
    $('.list-page-filter-clear a').click(resetFilters);
    requestResources();

})(jQuery);

$(document).on("click", ".currently-trending .resource-title", function() {
	var numberIndex = $(this).index();

	if (!$(this).is("active")) {
		$(".currently-trending .resource-title").removeClass("active");
		$(".currently-trending .resource-full-list .resource-full-container").removeClass("active");

		$(this).addClass("active");
		$(".currently-trending .resource-full-list").find(".resource-full-container:eq(" + numberIndex + ")").addClass("active");

		var listItemHeight = $(".currently-trending .resource-full-list")
			.find(".resource-full-container:eq(" + numberIndex + ")")
			.innerHeight();
		$(".currently-trending .resource-full-list").height(listItemHeight + "px");
	}
});

// function myCustomURLConverter(url, node, on_save, name) {
//     // Do some custom URL conversion
//     url = url.substring(3);
//     console.log(url)
//     // Return new URL
//     return url;
//   }

// tinyMCE.init({
//     selector: 'textarea',  // change this value according to your HTML
//     urlconverter_callback : 'myCustomURLConverter'
// });
